<template>
  <section class="page-section about-heading">
    <div class="container">
      <img
        class="img-responsive rounded about-heading-img mb-3 mb-lg-0"
        src="@/assets/img/provaScan.png"
        alt=""
      />
      <div class="about-heading-content">
        <div class="row">
          <div class="col-xl-9 col-lg-10 mx-auto">
            <div class="bg-faded rounded p-5">
              <h2 class="section-heading mb-4">
                <span class="section-heading-upper"
                  >Everything you may want to know</span
                >
                <span class="section-heading-lower">About Me</span>
              </h2>
              <p>
                I was born in 1994 and lived in Quartu Sant'Elena (Sardinia) all
                my life. I graduated in Chemistry in 2019. People usually
                describe me as a kind and humorous person. I can say I use
                whatever methods I can to get to people's trust, and make sure
                to make such always stable to maintain all the bonds I manage to
                develop.
              </p>
              <p>
                I consider myself to be <em>brutally</em> honest and transparent
                with anyone, even if it can get things uncomfortable. I consider
                transparency to be among the most (if not the top) important
                skills to develop to achieve the best environment between two or
                more people.
              </p>
              <p>
                I love to push myself out of my comfort zone because I consider
                such to be the most efficient way to grow and develop new
                skills. I lived many experiences that changed my life (for the
                better and worse), but I always welcome changes. Even more, I
                constantly force myself into situations which can trigger
                changes in my life so I can develop my adaptability and
                improvisation skill.
              </p>
              <p>
                I have (and had) many passions and dreams. I am a lot into video
                (and board) game design, and soon I will start studying some
                videogame development as well. I read many fantasy books, and I
                took some piano lessons for some time. I've been playing (and
                mastering) Dungeons & Dragons and Pathfinder campaigns for
                years, and sooner or later I will try some new role-playing
                systems as well. I recently started watching and analyzing
                movies as well as I do with games.
              </p>

              <p class="mb-0">
                The goals I'm aiming for at the moment revolve mostly around
                programming. I would like to develop my programming skills and
                becoming a senior developer. In doing so, I want to achieve
                economic independence as well, so I can be able to live on my
                own. I would like to start taking drums and graffiti lessons to
                feel more fulfilled artistically. Finally, I want to travel as
                much as I can, and maybe to try to live in many different
                places, so I can enrich my culture as much as I can.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data: function () {
    return {
      number: 1,
    };
  },
};
</script>

<style lang="scss">
.about-heading {
  @media (min-width: 992px) {
    .about-heading-img {
      position: relative;
      z-index: 0;
    }
    .about-heading-content {
      margin-top: -5rem;
      position: relative;
      z-index: 1;
    }
  }
}
</style>
